
import { Component, Vue } from 'vue-property-decorator';
import { getDeptSerOrderWorkTimeTrend } from '@/api/statisticsDeptOrder';
import { UserModule } from '@/store/modules/user';
import DialogLveReportDept from '@/components/DeptLev/index.vue';
import {
  CHART_TIME_TYPE_CURRENT_MONTH,
  CHART_TIME_TYPE_OPTIONS
} from '@/const/ChartTimeType';
var echarts = require('echarts');

@Component({
  name: 'StatisticsDeptSerOrderWorkTime',
  components: {
    DialogLveReportDept
  }
})
export default class extends Vue {
  private formSearch: any = {
    timeType: CHART_TIME_TYPE_CURRENT_MONTH
  }
  private timeTypeOptions: any[] = CHART_TIME_TYPE_OPTIONS;
  private deptSelectName = '';
  private deptSelectId: any = 0;
  private servicerCompanyId = '';
  private departmentLevVisible = false;
  private departmentLevSelect: any = { id: 0, name: '' };
  private loading = false;
  private chartEmpty = false;
  private rawList: any[] = [];
  private myChart: any = null;

  created() {
    this.servicerCompanyId = UserModule.getCompanyId;
    this.getList();
  }

  mounted() {
    window.addEventListener('resize', this.handleResize);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.myChart) {
      this.myChart.dispose();
      this.myChart = null;
    }
  }

  private handleResize() {
    if (this.myChart) {
      this.myChart.resize();
    }
  }

  private handleTimeTypeChange() {
    this.getList();
  }

  private handleSearch() {
    this.getList();
  }

  private handleClear() {
    this.deptSelectName = '';
    this.deptSelectId = 0;
    this.getList();
  }

  // 选择部门
  private openDeptDialog() {
    this.departmentLevSelect = { id: 0, name: '' };
    this.departmentLevVisible = true;
  }

  private selectDeptLev(value: any) {
    this.departmentLevSelect = value;
  }

  private handleLveReportDeptConfirm() {
    this.deptSelectId = this.departmentLevSelect.id;
    this.deptSelectName = this.departmentLevSelect.name;
    this.departmentLevVisible = false;
    this.departmentLevSelect = { id: 0, name: '' };
  }

  private closeDialogLveReportDept() {
    this.departmentLevVisible = false;
    this.departmentLevSelect = { id: 0, name: '' };
  }

  private handleDeptClear() {
    this.deptSelectName = '';
    this.deptSelectId = 0;
    this.getList();
  }

  private getList() {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      time_type: this.formSearch.timeType
    };
    if (this.deptSelectId) {
      params.dept_pid = this.deptSelectId;
    }
    this.loading = true;
    getDeptSerOrderWorkTimeTrend(params).then(res => {
      const list = (res && res.data && res.data.line_chart_list) ? res.data.line_chart_list : [];
      this.rawList = list;
      this.renderChart();
      this.loading = false;
    }).catch(err => {
      if (!err.data) {
        this.rawList = [];
        this.renderChart();
      }
      this.loading = false;
    });
  }

  private renderChart() {
    const filtered = this.rawList;

    if (!filtered || filtered.length === 0) {
      this.chartEmpty = true;
      if (this.myChart) {
        this.myChart.clear();
      }
      return;
    }
    this.chartEmpty = false;

    // 收集 x 轴时间点（合并所有部门的时间点，保持顺序）
    const xSet: string[] = [];
    filtered.forEach((dept: any) => {
      if (dept.line_chart && dept.line_chart.length > 0) {
        dept.line_chart.forEach((point: any) => {
          const xVal = String(point.x);
          if (xSet.indexOf(xVal) === -1) {
            xSet.push(xVal);
          }
        });
      }
    });

    // 按数字大小排序（支持 2024 / 2026.1 / 7.3 等格式）
    xSet.sort((a: string, b: string) => {
      const partsA = a.split('.').map((n: string) => parseInt(n, 10) || 0);
      const partsB = b.split('.').map((n: string) => parseInt(n, 10) || 0);
      const len = Math.max(partsA.length, partsB.length);
      for (let i = 0; i < len; i++) {
        const va = partsA[i] || 0;
        const vb = partsB[i] || 0;
        if (va !== vb) {
          return va - vb;
        }
      }
      return 0;
    });

    // 构造每个部门一个 series（折线图，不堆叠）
    const palette = ['#8DB9FC', '#18CA9B', '#BB89FB', 'rgb(255, 165, 0)', 'rgb(128, 128, 128)', '#FF6B6B'];
    const lastIndex = filtered.length - 1;
    const series = filtered.map((dept: any, index: number) => {
      const data = xSet.map((xVal: string) => {
        const point = (dept.line_chart || []).find((p: any) => String(p.x) === xVal);
        return point ? Number(point.y) : 0;
      });
      // 最后一个为平均值，红色
      const isAvg = index === lastIndex;
      return {
        name: dept.dept_name,
        type: 'line',
        smooth: true,
        itemStyle: isAvg ? { color: '#E74C3C' } : undefined,
        lineStyle: isAvg ? { color: '#E74C3C', width: 2 } : undefined,
        emphasis: { focus: 'series' },
        data: data
      };
    });

    this.$nextTick(() => {
      const dom = document.getElementById('deptSerOrderWorkTime-echarts');
      if (!dom) {
        return;
      }
      if (!this.myChart) {
        this.myChart = echarts.init(dom);
      }
      const option = {
        title: {
          text: '服务部门平均工时',
          left: 'center'
        },
        color: palette,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985',
              formatter: (params: any) => {
                if (params.axisDimension === 'y') {
                  const total = Math.round(params.value);
                  const h = Math.floor(total / 60);
                  const m = Math.abs(total) % 60;
                  return h + ':' + String(m).padStart(2, '0');
                }
                return params.value;
              }
            }
          },
          formatter: (params: any) => {
            let html = params[0].axisValueLabel + '<br/>';
            params.forEach((p: any) => {
              const total = Math.round(p.value);
              const h = Math.floor(total / 60);
              const m = Math.abs(total) % 60;
              const text = h + '小时' + String(m).padStart(2, '0') + '分';
              html += p.marker + p.seriesName + '：' + text + '<br/>';
            });
            return html;
          }
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 30,
          icon: 'circle',
          lineStyle: {
            width: 0
          },
          textStyle: {
            fontSize: 16
          },
          data: filtered.map((dept: any) => dept.dept_name)
        },
        grid: {
          left: 30,
          right: 50,
          top: 60,
          bottom: 80,
          containLabel: true
        },
        toolbox: {
          show: false
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xSet
        },
        yAxis: {
          type: 'value',
          name: '工时',
          axisLabel: {
            formatter: (val: number) => {
              const total = Math.round(val);
              const h = Math.floor(total / 60);
              const m = Math.abs(total) % 60;
              return h + ':' + String(m).padStart(2, '0');
            }
          }
        },
        series: series
      };
      this.myChart.setOption(option, true);
      this.myChart.resize();
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
